// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__CJ_Ft","inner":"Form_inner__3emmY","range":"Form_range__2h47q","name":"Form_name__2cwPG","actions":"Form_actions__2Xczd"};